'use client'

import cn from 'clsx'
import { useLenis } from 'lenis/react'
import { Image } from '~/components/image'
import { Link } from '~/components/link'

export function Navigation() {
  const lenis = useLenis()

  const backToTop = () => {
    if (lenis) {
      lenis?.scrollTo(0)
    }
  }

  return (
    <header className="max-w-[1440px] mx-auto fixed left-0 z-[2] right-0  pointer-events-none">
      <div className="dr-w-393 dt:w-full dr-py-29 dr-px-20 dt:dr-px-30 dr-top-20 dt:dr-top-30 flex justify-between items-center">
        <button
          type="button"
          onClick={backToTop}
          className="flex dr-w-80 dt:dr-w-90 cursor-pointer pointer-events-auto shrink-0"
          aria-label="Scroll to top"
        >
          <Image src="/images/logo.png" alt="Cora logo" className="!w-full" />
        </button>

        <nav className="flex items-center justify-end pointer-events-auto  bg-[#ffffffE5] backdrop-blur-[29px] dr-gap-10 dr-pl-16 dr-p-1 dt:dr-gap-9.5 dr-rounded-9999 dt:dr-pl-23 nav-cta overflow-clip">
          <a
            href="https://cora.computer/users/sign_in"
            className={cn(' uline transition-all duration-300 text-tertiary')}
          >
            Log in
          </a>
          <Link
            href="https://cora.computer/users/sign_up"
            className={cn(
              'bg-primary dr-py-10 dr-px-16 dt:dr-py-8 dt:dr-px-23 dr-rounded-9999 whitespace-nowrap border-solid border-secondary dr-border-2  transition-all duration-300 hover:bg-[#d6d6d6] hover:text-[#000] hover:shadow-[-3px_4px_4px_0px_#00000010] hover:backdrop-blur-[20px]'
            )}
          >
            Start free trial
          </Link>
        </nav>
      </div>
    </header>
  )
}
